export interface BlogPost {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  coverImageUrl: string;
  authorName: string;
  createdAt: string;
}

export const blogPosts: BlogPost[] = [];
